module.exports = __webpack_public_path__ + "img/top3.0ee7e95e.png";